import styled from 'styled-components';
import { COLOR, FONT_SIZE, RADIUS, SPACING } from '../../../constants/theme';

const InlineAlert = styled.div`
  margin-top: ${SPACING.md};
  padding: 10px 14px;
  border: 1px solid ${COLOR.errorBorder};
  border-radius: ${RADIUS.md};
  background: ${COLOR.errorBackground};
  font-size: ${FONT_SIZE.body};
  line-height: 1.5;
  color: ${COLOR.errorText};
`;

export default InlineAlert;
